// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { orderDetailsService } from './service';
import * as orderDetailsActions from './actions';
import * as types from './actionTypes';

function* orderDetailsSaga(payload) {
  const res = yield call(orderDetailsService, payload.data);
  if (res.ok) {
    const order = res.body;
    yield put(orderDetailsActions.orderRequestSuccess(order));
  } else {
    yield put(orderDetailsActions.orderRequestFailed({ error: 'error' }));
  }
}

const orderDetailsSagas = [
  takeEvery(types.ORDER_REQUEST, orderDetailsSaga),
];

export default orderDetailsSagas;
